export const fr = {
  toast: {
    error: {
      offlineModuleModelNotSaveable: "Enregistrement hors ligne non autorisé",
    },
    success: {},
    warning: {},
  },
};
